import { SearchBy } from '@nkr/models/index';
import ISelectItem from './select-item';

export interface IFilter {
    center: number,
    type: number,
    status: number[],
    tier: number,
    group: number,
    tags: ISelectItem[],
    searchBy: SearchBy,
    search: string,
    startDate: string,
    endDate: string,
    allOpen: boolean
}